import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, categoryMap } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? categoryMap[slug] : undefined;
  const articles = slug ? getArticlesByCategory(slug) : [];

  const currentCategory = category;

  if (!currentCategory) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-4">分类不存在</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${currentCategory.name} - 援助交配现象研究`,
    description: currentCategory.description,
    url: `https://jiahe01.cn/category/${slug}`,
    inLanguage: 'zh-CN',
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }} />

      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: currentCategory.name },
            ]}
          />

          <div className="py-8 md:py-12">
            <div className="flex items-center gap-4 mb-8">
              <span className="w-14 h-14 flex items-center justify-center rounded-xl bg-accent-100">
                <i className={`${currentCategory.icon} text-2xl text-accent-700`}></i>
              </span>
              <div>
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  {currentCategory.name}
                </h1>
                <p className="text-foreground-600 text-sm mt-1">{currentCategory.description}</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-10">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {articles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {articles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}